/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const _SubmissionRubricItemDataParserParser = 
/* #__PURE__ */ parsers.object([
    ['itemId', codecNumber, 'item_id'],
    ['multiplier', /* #__PURE__ */ codecOptional(codecNumber)],
]);
export class _SubmissionRubricItemDataParser extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return _SubmissionRubricItemDataParserParser
            .decode(input)
            .map(res => new _SubmissionRubricItemDataParser(res));
    }
    static unsafeDecode(input) {
        return _SubmissionRubricItemDataParser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return _SubmissionRubricItemDataParserParser.encode(data);
    }
    static schema() {
        return _SubmissionRubricItemDataParserParser.schema();
    }
}
